import * as types from "../../../_constants/types";

export default (state = { loading: false }, action) => {
    switch (action.type) {
        case types.RETURN_REASON_LIST_FETCHING:
            return { loading: true };

        case types.RETURN_REASON_LIST_FETCHING_COMPLETED:
            return { loading: false };

        case types.RETURN_REASON_LIST_FETCHING_CANCELLED:
            if (!state.loading) {
                return { loading: false, err: action.err };
            }
            return state;

        case types.RETURN_REASON_LIST_FETCHING_FAILED:
            return { loading: false, err: action.err };

        default:
            return state;
    }
};
